import { BookmakerSelect as BookmakerSelectComponent } from './BookmakerSelect.component';
import { connector } from './BookmakerSelect.connector';

export const BookmakerSelect = connector(BookmakerSelectComponent);
